import { render, staticRenderFns } from "./formEdit.vue?vue&type=template&id=1644d58f"
import script from "./formEdit.vue?vue&type=script&lang=js"
export * from "./formEdit.vue?vue&type=script&lang=js"
import style0 from "./formEdit.vue?vue&type=style&index=0&id=1644d58f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports